import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface GetEventStudentCountResponse {
  count: number;
}

export const getEventStudentCountAPI = async (eventId: string) => {
  const response = await baseAPI.get<GetEventStudentCountResponse>(
    `students/count/event/${eventId}`,
  );
  return response.data;
};

export const getEventStudentCountQueryOptions = (
  eventId: string,
  enabled: boolean,
) =>
  queryOptions({
    queryKey: [KEYS.EVENTS, eventId, KEYS.STUDENT_COUNT],
    queryFn: () => getEventStudentCountAPI(eventId),
    enabled: enabled,
    staleTime: 0,
  });

export const useGetEventStudentCount = ({
  eventId,
  enabled,
}: {
  eventId: string;
  enabled: boolean;
}) => {
  return useQuery({
    ...getEventStudentCountQueryOptions(eventId, enabled),
  });
};
